/** 개인정보 처리방침（본문은 이 파일에서 관리） */
export const privacyTitle = '개인정보 보호정책';

export const privacyBody =
`제1장 총칙
(목적)
제1조
본 규정은 주식회사 Japan DX(이하 「당사」라 함)가 본 회의에 있어서 개인정보 등의 취급에 관한 기본사항을 정하는 것이며, 본 규정을 준수하는 범위 내에서 개인정보 등의 취급에 관한 세칙을 정할 수 있다. 다만, 본 회의 종업원의 개인정보 취급에 대해서는 별도로 정하는 바에 따른다.
(정의)
제2조
본 규정에서 사용하는 용어의 정의는 다음과 같다.
(1) 개인정보
생존하는 개인에 관한 정보로서, 해당 정보에 포함된 성명, 생년월일 그 밖의 기재사항 등에 의하여 특정 개인을 식별할 수 있는 것(다른 정보와 용이하게 대조할 수 있고, 이로써 특정 개인을 식별할 수 있게 되는 것을 포함한다)을 말한다.
(2) 개인정보 데이터베이스 등
개인정보를 포함하는 정보의 집합체로서 다음에 해당하는 것을 말한다.
가. 특정 개인정보를 전자컴퓨터를 이용하여 검색할 수 있도록 체계적으로 구성한 것
나. 가에 해당하는 것 외에, 해당 정보 집합체에 포함된 개인정보를 일정한 규칙에 따라 정리함으로써 특정 개인정보를 용이하게 검색할 수 있도록 체계적으로 구성한 정보 집합체로서, 목차, 색인 그 밖에 검색을 용이하게 하기 위한 것을 갖춘 것
(3) 개인데이터
개인정보 데이터베이스 등을 구성하는 개인정보를 말한다.
(4) 보유개인데이터
본 회의가 공개, 내용의 정정·추가 또는 삭제, 이용의 정지, 삭제 및 제3자에 대한 제공 정지를 할 수 있는 권한을 가지는 개인데이터 전부로서 다음에 해당하는 것을 제외한 것을 말한다.
가. 해당 개인데이터의 존재 여부가 명확해짐으로써 공익 그 밖의 이익이 침해되는 것
나. 6개월 이내에 삭제하기로 한 것
(5) 본인
개인정보에 의하여 식별되는 특정 개인을 말한다.
(개인정보보호 총괄관리자 등)
제3조
(1) 개인정보의 보호를 위한 조치에 관한 업무를 총괄하는 자로서 개인정보보호 총괄관리자를 두며, 개인정보보호 총괄관리자가 그 직무를 수행한다.
제2장 개인정보
(취득의 원칙)
제4조
(1) 개인정보는 사업·업무상 필요한 범위 내에서 취득하는 것으로 하며, 사전에 이용목적을 특정하고, 그 목적의 달성에 필요한 한도 내에서 행한다.
(2) 원칙적으로 다음의 내용을 포함하는 개인정보의 취득, 이용 또는 제공을 행하지 않는다.
사상, 신조 및 종교에 관한 사항
인종, 민족, 문벌, 본적지(도도부현 제외) 그 밖에 사회적 차별의 원인이 되는 사항
(적정한 취득)
제5조
거짓 그 밖의 부정한 수단으로 개인정보를 취득해서는 안 된다.
(이용목적의 공표 또는 통지)
제6조
(1) 개인정보 취득 시, 원칙적으로 다음 사항을 홈페이지, 기관지 등으로 공표한다.
이용목적
개인데이터의 제3자 제공에 관한 사항
개인데이터의 공동이용에 관한 사항
(2) 이용목적을 공표하지 않은 경우, 개인정보 취득 시 그 이용목적을 서면 또는 구두로 본인에게 통지한다. 다만 다음의 경우는 제외한다.
이용목적을 본인에게 통지하거나 공표함으로써 본인 또는 제3자의 생명, 신체, 재산 그 밖의 권리이익을 해할 우려가 있는 경우
이용목적을 본인에게 통지하거나 공표함으로써 본 회의의 권리 또는 정당한 이익을 해할 우려가 있는 경우
국가기관 또는 지방자치단체가 법령이 정하는 사무를 수행하는 것에 협력할 필요가 있는 경우로서, 이용목적을 본인에게 통지하거나 공표함으로써 해당 사무의 수행에 지장을 줄 우려가 있는 때
취득 상황으로 보아 이용목적이 명백하다고 인정되는 경우
(3) 제1항에 규정된 각 호의 제정 및 개변에 대해서는 경미한 수정을 제외하고 개인정보보호 총괄책임자의 승인을 얻어야 한다.
제3장 개인데이터
(정확성 확보)
제7조
개인데이터에 대해서는 정확하고 최신의 내용을 유지하도록 노력한다.
(보존기간)
제8조
개인데이터에 대해서는 이용목적 달성에 필요한 범위 내에서 보존기간을 정하도록 노력하며, 해당 보존기간 경과 후 또는 이용목적을 달성한 후에는 지체 없이 이를 삭제하도록 노력한다.
(안전관리조치)
제9조
(1) 개인데이터의 유출, 멸실 또는 훼손(이하 「유출 등」이라 함)을 방지하기 위하여 다음 조치를 강구한다.
기술적 관리조치로서 부정접근으로부터 방어하도록 노력한다.
인적 관리조치로서 개인정보의 유출 등이 발생하지 않도록 종업원에게 철저히 주지시킨다. 또한 필요에 따라 비밀유지계약을 체결한다.
(2) 종업원은 개인정보의 유출 등이 발생하지 않도록 사전에 방지하기 위해 노력해야 한다.
(수탁자의 감독)
제10조
개인데이터의 취급을 외부에 위탁하는 경우, 수탁자와 비밀유지에 관한 사항, 재위탁에 관한 사항 및 전조에서 정한 안전관리조치에 관한 사항에 대해 계약을 체결한다.
(제3자 제공의 제한)
제11조
(1) 개인데이터를 제3자에게 제공하는 경우, 사전에 서면 또는 구두로 명시적인 본인의 동의를 얻어야 한다. 다만 다음의 경우는 제외한다.
법령에 근거하는 경우
사람의 생명, 신체 또는 재산의 보호를 위해 필요한 경우로서 본인의 동의를 얻기 어려운 때
공중위생의 향상 또는 아동의 건전한 양성 증진을 위해 특히 필요한 경우로서 본인의 동의를 얻기 어려운 때
국가기관 또는 지방자치단체 또는 그 수탁자가 법령이 정하는 사무를 수행하는 것에 협력할 필요가 있는 경우로서 본인의 동의를 얻음으로써 해당 사무 수행에 지장을 줄 우려가 있는 때
이용목적 달성에 필요한 범위 내에서 개인데이터의 취급을 위탁하는 경우
제6조 제1항 제2호에 따라 개인정보보호법 제23조 제2항이 정하는 사항을 공표하고 있는 때
제6조 제1항 제3호에 따라 개인정보보호법 제23조 제4항 제3호가 정하는 사항을 공표하고 있는 때
(2) 개인데이터를 제3자에게 제공하는 경우, 사전에 개인정보사무관리자에게 신고한 후 개인정보보호 총괄관리자의 승인을 얻어야 한다. 다만 전항 제5호에 해당하는 경우, 전항 제6호 또는 제7호에 규정된 조치를 강구하고 있는 경우, 및 긴급을 요하는 경우는 제외한다.
제4장 보유개인데이터
(보유개인데이터에 관한 사항의 공표 등)
제12조
(1) 본인으로부터 해당 본인이 식별되는 보유개인데이터의 이용목적 통지를 요구받은 경우, 지체 없이 이를 통지한다. 다만 다음의 경우는 제외한다.
보유개인데이터의 이용목적이 명백한 경우
제6조 제2항 제1호부터 제3호까지에 해당하는 경우
(2) 전항의 규정에 따라 요구받은 보유개인데이터의 이용목적을 통지하지 않기로 결정한 때는 본인에 대해 지체 없이 해당 결정 사실을 통지한다.
(공개)
제13조
(1) 본인으로부터 해당 본인이 식별되는 보유개인데이터의 공개(해당 본인이 식별되는 보유개인데이터가 존재하지 않을 때는 그 취지를 알리는 것을 포함한다. 이하 같다)를 요구받은 때는 서면 또는 본인이 동의한 방법으로 지체 없이 해당 보유데이터를 공개한다. 다만 다음의 경우는 제외한다.
본인 또는 제3자의 생명, 신체, 재산 그 밖의 권리이익을 해할 우려가 있는 경우
본 회의 업무의 적정한 수행에 현저한 지장을 줄 우려가 있는 경우
다른 법령에 위배되는 경우
(2) 전항의 규정에 따라 요구받은 보유개인데이터의 전부 또는 일부에 대해 공개하지 않기로 결정한 때는 본인에 대해 지체 없이 해당 결정 사실 및 근거 조항을 통지한다.
(3) 다른 법령의 규정에 따라 본인에 대해 제1항 본문에 규정된 방법에 상당하는 방법으로 해당 본인이 식별되는 보유개인데이터의 전부 또는 일부를 공개하기로 한 경우, 동항의 규정은 적용하지 않는다.
(정정 등)
제14조
(1) 본인으로부터 해당 본인이 식별되는 보유개인데이터의 내용이 사실과 다르다는 이유로 해당 보유개인데이터 내용의 정정, 추가 또는 삭제(이하 「정정 등」이라 함)를 요구받은 경우, 이용목적 달성에 필요한 범위 내에서 지체 없이 사실확인 등 필요한 조사를 실시하고, 그 결과에 따라 해당 보유개인데이터 내용의 정정 등을 한다.
(2) 전항에 따라 정정 등을 한 때, 또는 하지 않기로 결정한 때는 본인에 대해 지체 없이 그 취지(정정 등을 한 때는 그 내용을 포함한다)를 통지한다.
(이용정지 등)
제15조
(1) 본인으로부터 개인정보보호법 제16조(이용목적에 의한 제한) 또는 제17조(적정한 취득)에 위반된다는 이유로 보유개인데이터의 이용정지 또는 삭제를 요구받은 경우로서 그 요구에 정당한 이유가 있다고 판명된 때는 필요한 한도 내에서 지체 없이 해당 보유데이터의 이용정지 등을 하거나, 이가 어려운 경우는 본인의 권리이익을 보호하기 위해 필요한 이에 갈음할 조치를 강구한다.
(2) 본인으로부터 개인정보보호법 제23조(제3자 제공의 제한)에 위반된다는 이유로 보유개인데이터의 제3자에 대한 제공정지를 요구받은 경우로서 그 요구에 정당한 이유가 있다고 판명된 때는 필요한 한도 내에서 지체 없이 해당 보유데이터의 제3자에 대한 제공을 정지하거나, 이가 어려운 경우는 본인의 권리이익을 보호하기 위해 필요한 이에 갈음할 조치를 강구한다.
(3) 전2항의 각 조치를 한 때, 또는 하지 않기로 결정한 때는 지체 없이 그 취지를 본인에게 통지한다.
(이유 설명)
제16조
제12조 제2항, 제13조 제2항, 제14조 제2항, 전조 제3항의 규정에 따라 본인으로부터 요구받은 조치의 전부 또는 일부에 대해 그 조치를 취하지 않는다는 취지를 통지하거나 그 조치와 다른 조치를 취한다는 취지를 통지하는 경우, 본인에 대해 그 이유를 설명하도록 노력한다.
제5장 유출 등에 대한 대응
(유출 등이 발생한 경우의 대응)
제17조
(1) 유출 등의 사실을 파악한 종업원은 그 사실을 신속하게 개인정보보호사무관리자에게 구두로 보고해야 한다.
(2) 개인정보보호사무관리자는 2차 피해 방지, 유사 사건 발생 회피 등을 위해 사실관계를 신속하게 조사·확인함과 동시에 가능한 한 사실관계 등을 공표하도록 노력한다. 또한 사실관계 조사·확인에 시간이 필요한 경우에도 2차 피해 방지 관점에서 유출 사실 공표 등을 실시하여 사회적 신뢰 회복에 노력한다.
(이상)
`;
